webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(42);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(65);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(64);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _router = __webpack_require__(6);
	
	var _router2 = _interopRequireDefault(_router);
	
	__webpack_require__(33);
	
	var _mintUi = __webpack_require__(34);
	
	var _mintUi2 = _interopRequireDefault(_mintUi);
	
	__webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.use(_mintUi2.default);
	
	var router = new _vueRouter2.default(_router2.default);
	new _vue2.default({
	  router: router,
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(22)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(11),
	  /* template */
	  __webpack_require__(53),
	  /* scopeId */
	  "data-v-0258c3a1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(23)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(13),
	  /* template */
	  __webpack_require__(54),
	  /* scopeId */
	  "data-v-0be5e79d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _movie = __webpack_require__(50);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _book = __webpack_require__(43);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _broadcast = __webpack_require__(45);
	
	var _broadcast2 = _interopRequireDefault(_broadcast);
	
	var _group = __webpack_require__(48);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _movie3 = __webpack_require__(49);
	
	var _movie4 = _interopRequireDefault(_movie3);
	
	var _search = __webpack_require__(47);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mode: 'history',
	  scrollBehavior: function scrollBehavior() {
	    return { y: 0 };
	  },
	  routes: [{ path: '/', component: _movie2.default }, { path: '/movie', component: _movie2.default }, { path: '/movie/subject/:id', component: _movie4.default }, { path: '/book', component: _book2.default }, { path: '/broadcast', component: _broadcast2.default }, { path: '/group', component: _group2.default }, { path: '/search', component: _search2.default }, { path: '*', redirect: '/' }]
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(46);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {};
	  },
	
	  components: {
	    Vheader: _header2.default
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navtype = __webpack_require__(3);
	
	var _navtype2 = _interopRequireDefault(_navtype);
	
	var _download = __webpack_require__(2);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _bookSwipe = __webpack_require__(44);
	
	var _bookSwipe2 = _interopRequireDefault(_bookSwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'books',
	  data: function data() {
	    return {
	      Title: ['最受关注图书 | 虚构类', '最受关注图书 | 非虚构类', '豆瓣纸书'],
	      title: '分类浏览',
	      msg: ['小说', '爱情', '历史', '外国文学', '青春', '励志', '随笔', '传记', '推理', '旅行', '奇幻', '经管']
	    };
	  },
	
	  components: {
	    types: _navtype2.default,
	
	    Vbottom: _download2.default,
	
	    Vswipe: _bookSwipe2.default
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'bookSwipe',
	  data: function data() {
	    return {
	      data: { 'data': [], 'data2': [], 'data3': [] },
	      url: 'https://api.douban.com/v2/book/'
	    };
	  },
	
	  methods: {},
	  created: function created() {
	    var _this = this;
	
	    var opt = {
	      params: {
	        'apikey': '00fa6c0654689a0202ef4412fd39ce06'
	      }
	    };
	
	    this.$http.jsonp(this.url + '26948733', opt).then(function (res) {
	      _this.data.data = res.data;
	    });
	    this.$http.jsonp(this.url + '26939261', opt).then(function (res) {
	      _this.data.data2 = res.data;
	    });
	    this.$http.jsonp(this.url + '26845771', opt).then(function (res) {
	      _this.data.data3 = res.data;
	    });
	  },
	
	  components: {}
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      isShowSearch: false,
	      NavData: [{
	        title: '电影',
	        description: '影院热映',
	        color: 'rgb(35, 132, 232)'
	      }, {
	        title: '电视',
	        description: '正在热播',
	        color: 'rgb(122, 106, 219)'
	      }, {
	        title: '图书',
	        description: '畅销排行',
	        color: 'rgb(159, 120, 96)'
	      }, {
	        title: '同城',
	        description: '周末活动',
	        color: 'rgb(230, 70, 126)'
	      }, {
	        title: '小组',
	        description: '志趣相投',
	        color: 'rgb(42, 184, 204)'
	      }, {
	        title: '音乐',
	        description: '新碟榜',
	        color: 'rgb(244, 143, 46)'
	      }, {
	        title: '阅读',
	        description: '电子书',
	        color: 'rgb(159, 120, 96)'
	      }, {
	        title: '游戏',
	        description: '虚拟世界',
	        color: 'rgb(87, 116, 197)'
	      }, {
	        title: '应用',
	        description: '玩手机',
	        color: 'rgb(89, 108, 221)'
	      }, {
	        title: '东西',
	        description: '心爱之物',
	        color: 'rgb(89, 108, 221)rgb(225, 100, 77)'
	      }, {
	        title: 'FM',
	        description: '红心歌单',
	        color: 'rgb(64, 207, 169)'
	      }, {
	        title: '市集',
	        description: '购买原创',
	        color: 'rgb(66, 189, 86)'
	      }]
	    };
	  },
	
	  components: {},
	  methods: {
	    showSearch: function showSearch() {
	      this.isShowSearch = !this.isShowSearch;
	    }
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            typeData: ['经典', '冷片佳片', '豆瓣高分', '动作', '喜剧', '爱情', '悬疑', '恐怖', '科幻', '治愈', '文艺', '成长', '动画', '华语', '欧美', '韩国', '日本', '']
	        };
	    }
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'search',
	  data: function data() {
	    return {
	      data: [],
	      subjects: [],
	      musicData: [],
	      musics: [],
	      bookData: [],
	      books: [],
	      dataShow: true,
	      musicShow: true,
	      bookShow: true
	    };
	  },
	
	  methods: {},
	  created: function created() {
	    var _this = this;
	
	    var query = this.$route.query.query;
	    var opt = {
	      params: {
	        'start': 0,
	        'count': 3,
	        'apikey': '00fa6c0654689a0202ef4412fd39ce06'
	      }
	    };
	
	    this.$http.jsonp(decodeURI('https://api.douban.com/v2/movie/search?q=' + query), opt).then(function (res) {
	      _this.data = res.data;
	      _this.subjects = res.data.subjects;
	      _this.$nextTick(function () {
	        if (_this.subjects.length === 0) {
	          return _this.dataShow;
	        }
	      });
	    });
	
	    this.$http.jsonp(decodeURI('https://api.douban.com/v2/music/search?q=' + query), opt).then(function (res) {
	      _this.musicData = res.data;
	      _this.musics = res.data.musics;
	      _this.$nextTick(function () {
	        if (_this.musics.length === 0) {
	          return _this.musicShow;
	        }
	      });
	    });
	
	    this.$http.jsonp(decodeURI('https://api.douban.com/v2/book/search?q=' + query), opt).then(function (res) {
	      _this.bookData = res.data;
	      _this.books = res.data.books;
	      _this.$nextTick(function () {
	        if (_this.books.length === 0) {
	          return _this.bookShow;
	        }
	      });
	    });
	  },
	
	  components: {}
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      url: 'https://api.douban.com/v2/movie/subject/',
	      data: {},
	      slogan: ['用 App 打开', '查看影片获奖情况'],
	      datai: '',
	      star: ''
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var id = this.$route.params.id;
	    this.$http.jsonp(this.url + id, {
	      'apikey': '00fa6c0654689a0202ef4412fd39ce06'
	    }).then(function (res) {
	      _this.data = res.data;
	      _this.datai = res.data.images.medium;
	      _this.star = res.data.rating.average;
	    }, function (err) {
	      console.log(err);
	    });
	  },
	
	  components: {}
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _movieItem = __webpack_require__(51);
	
	var _movieItem2 = _interopRequireDefault(_movieItem);
	
	var _navtype = __webpack_require__(3);
	
	var _navtype2 = _interopRequireDefault(_navtype);
	
	var _download = __webpack_require__(2);
	
	var _download2 = _interopRequireDefault(_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'movie',
	  data: function data() {
	    return {
	      url: 'https://api.douban.com/v2/movie/',
	      Title: ['影院热映', 'TOP250', '即将上映']
	    };
	  },
	
	  components: {
	    movieItem: _movieItem2.default,
	    navtype: _navtype2.default,
	    download: _download2.default
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _betterScroll = __webpack_require__(19);
	
	var _betterScroll2 = _interopRequireDefault(_betterScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LENGTH = 5;
	var CLS_FULL = 'full';
	var CLS_GREY = 'grey';
	exports.default = {
	  props: {
	    url: String,
	    Title: String
	  },
	  data: function data() {
	    return {
	      movies: [],
	      starClassesData: []
	    };
	  },
	
	  methods: {
	    _initScroll: function _initScroll() {
	      this.moviesScroll = new _betterScroll2.default(this.$refs.moviesUl, {
	        scrollX: true,
	        eventPassthrough: 'vertical',
	        click: true
	      });
	    }
	  },
	  computed: {
	    starClasses: function starClasses() {
	      for (var i = 0; i < this.movies.length; i++) {
	        var result = [];
	        var fullCount = Math.floor(this.movies[i].rating.average / 2);
	        var greyCount = LENGTH - fullCount;
	        for (var j = 0; j < fullCount; j++) {
	          result.push(CLS_FULL);
	        }
	        for (var k = 0; k < greyCount; k++) {
	          result.push(CLS_GREY);
	        }
	
	        this.starClassesData.push(result);
	      }
	      return this.starClassesData;
	    }
	  },
	  created: function created() {
	    var opt = {
	      params: {
	        'count': 8,
	        'start': 0,
	        'apikey': '00fa6c0654689a0202ef4412fd39ce06'
	      }
	    };
	
	    this.$http.jsonp(this.url, opt).then(function (response) {
	      var _this = this;
	
	      this.movies = response.data.subjects;
	      this.$nextTick(function () {
	        _this._initScroll();
	      });
	    }, function (response) {
	      console.log(response);
	    });
	  },
	  compontents: {}
	};

/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 22 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 23 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 24 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 25 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 26 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 27 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 28 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 29 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 30 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 31 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/1324.bf16a0f.jpg";

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/1384.fde2cfe.jpg";

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/898.4edf29b.jpg";

/***/ },
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(32)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(63),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(26)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(8),
	  /* template */
	  __webpack_require__(57),
	  /* scopeId */
	  "data-v-37b614ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(30)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(61),
	  /* scopeId */
	  "data-v-8d16377e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(28)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(10),
	  /* template */
	  __webpack_require__(59),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(25)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(12),
	  /* template */
	  __webpack_require__(56),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(27)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(58),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(24)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(15),
	  /* template */
	  __webpack_require__(55),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(29)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(16),
	  /* template */
	  __webpack_require__(60),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(21)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(17),
	  /* template */
	  __webpack_require__(52),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(31)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(18),
	  /* template */
	  __webpack_require__(62),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('movieItem', {
	    attrs: {
	      "Title": _vm.Title[0],
	      "url": _vm.url + "in_theaters"
	    }
	  }), _vm._v(" "), _c('movieItem', {
	    attrs: {
	      "Title": _vm.Title[1],
	      "url": _vm.url + "top250"
	    }
	  }), _vm._v(" "), _c('movieItem', {
	    attrs: {
	      "Title": _vm.Title[2],
	      "url": _vm.url + "coming_soon"
	    }
	  }), _vm._v(" "), _c('navtype'), _vm._v(" "), _c('download')], 1)
	},staticRenderFns: []}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "download-wrapper"
	  }, [_c('div', {
	    staticClass: "info"
	  }, [_c('img', {
	    attrs: {
	      "src": "https://img3.doubanio.com/f/talion/7837f29dd7deab9416274ae374a59bc17b5f33c6/pics/card/douban-app-logo.png",
	      "alt": "",
	      "width": "48px",
	      "height": "48px"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "info-title"
	  }, [_c('strong', [_vm._v("豆瓣")]), _vm._v(" "), _c('span', [_vm._v("我们的精神角落")])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("免费下载 Android 客户端")])])])
	}]}

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "navtype"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content clearfix"
	  }, [_c('ul', {
	    staticClass: "type-list"
	  }, _vm._l((_vm.typeData), function(type) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(type))])])
	  }))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h2', [_vm._v("分类浏览")])])
	}]}

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "group"
	  }, [_c('h1', {
	    staticStyle: {
	      "text-align": "center",
	      "font-size": "25px",
	      "color": "deepskyblue",
	      "margin-top": "100px"
	    }
	  }, [_vm._v("This is group page!")]), _vm._v(" "), _c('mt-swipe', {
	    attrs: {
	      "show-indicators": false
	    }
	  }, [_c('mt-swipe-item', [_vm._v("1")]), _vm._v(" "), _c('mt-swipe-item', [_vm._v("2")]), _vm._v(" "), _c('mt-swipe-item', [_vm._v("3")])], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-wrapper"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._m(0), _vm._v(" "), _c('nav', {
	    staticClass: "nav"
	  }, [_c('ul', [_c('li', [_c('router-link', {
	    staticClass: "item",
	    staticStyle: {
	      "color": "#0a8ddf"
	    },
	    attrs: {
	      "to": "/movie"
	    }
	  }, [_vm._v("电影")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "item",
	    staticStyle: {
	      "color": "#9F7860"
	    },
	    attrs: {
	      "to": "/book"
	    }
	  }, [_vm._v("图书")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "item",
	    staticStyle: {
	      "color": "#E4A813"
	    },
	    attrs: {
	      "to": "/broadcast"
	    }
	  }, [_vm._v("广播")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "item",
	    staticStyle: {
	      "color": "#2AB8CC"
	    },
	    attrs: {
	      "to": "/group"
	    }
	  }, [_vm._v("小组")])], 1)]), _vm._v(" "), _c('span', {
	    staticClass: "search-btn",
	    on: {
	      "click": _vm.showSearch
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "enter-active-class": "animated fadeInLeft",
	      "leave-active-class": "animated fadeOutRight"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShowSearch),
	      expression: "isShowSearch"
	    }],
	    staticClass: "search-wrapper"
	  }, [_c('span', {
	    staticClass: "close",
	    on: {
	      "click": _vm.showSearch
	    }
	  }, [_vm._v("关闭")]), _vm._v(" "), _c('form', {
	    staticClass: "form",
	    attrs: {
	      "action": "/search",
	      "method": "GET"
	    }
	  }, [_c('div', [_c('input', {
	    attrs: {
	      "type": "search",
	      "name": "query"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    staticClass: "nav-list"
	  }, _vm._l((_vm.NavData), function(nav) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": ""
	      }
	    }, [_c('strong', {
	      style: ({
	        'color': nav.color
	      })
	    }, [_vm._v(_vm._s(nav.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(nav.description))])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "navBottom"
	  }, [_c('div', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("注册账号")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("登录豆瓣")])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("使用桌面版")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("使用豆瓣APP")])])])])])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('a', {
	    staticClass: "title",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("豆瓣")])])
	}]}

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "books"
	    }
	  }, [_c('Vswipe'), _vm._v(" "), _c('types', {
	    attrs: {
	      "title": _vm.title,
	      "msg": _vm.msg
	    }
	  }), _vm._v(" "), _c('Vbottom')], 1)
	},staticRenderFns: []}

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "search-res"
	  }, [_c('header', {
	    staticClass: "search-hd"
	  }, [_c('form', {
	    attrs: {
	      "action": "/search",
	      "method": "GET"
	    }
	  }, [_c('input', {
	    staticClass: "s-input",
	    attrs: {
	      "name": "query",
	      "autofocus": "",
	      "placeholder": _vm.$route.query.query
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    }
	  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('div', {
	    staticClass: "search-ct"
	  }, [_c('ul', [(_vm.dataShow) ? _c('li', {
	    staticClass: "search-module"
	  }, [_c('span', [_vm._v("影视")]), _vm._v(" "), _c('ul', _vm._l((_vm.subjects), function(item, i) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": ""
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.images.small,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "subject-info"
	    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_c('span', {
	      staticClass: "grade"
	    }, [_vm._v(_vm._s(item.rating.average == '0' ? '目前无人评价' : item.rating.average))])])])])])
	  })), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.data.total),
	      expression: "data.total"
	    }],
	    staticClass: "cl",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("更多影视结果( " + _vm._s(_vm.data.total) + " )")])]) : _vm._e(), _vm._v(" "), (_vm.musicShow) ? _c('li', {
	    staticClass: "search-module"
	  }, [_c('span', [_vm._v("音乐")]), _vm._v(" "), _c('ul', _vm._l((_vm.musics), function(item, i) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.image,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "subject-info"
	    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_c('span', {
	      staticClass: "grade"
	    }, [_vm._v(_vm._s(item.rating.average == '0' ? '目前无人评价' : item.rating.average))])])])])])
	  })), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.musicData.total),
	      expression: "musicData.total"
	    }],
	    staticClass: "cl",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("更多音乐结果( " + _vm._s(_vm.musicData.total) + " )")])]) : _vm._e(), _vm._v(" "), (_vm.bookShow) ? _c('li', {
	    staticClass: "search-module"
	  }, [_c('span', [_vm._v("读书")]), _vm._v(" "), _c('ul', _vm._l((_vm.books), function(item, i) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.image,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "subject-info"
	    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_c('span', {
	      staticClass: "grade"
	    }, [_vm._v(_vm._s(item.rating.average == '0.0' ? '目前无人评价' : item.rating.average))])])])])])
	  })), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.bookData.total),
	      expression: "bookData.total"
	    }],
	    staticClass: "cl",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("更多音乐结果( " + _vm._s(_vm.bookData.total) + " )")])]) : _vm._e(), _vm._v(" "), (_vm.dataShow && _vm.bookShow && _vm.musicShow ? false : true) ? _c('span', [_vm._v("没有搜索到,换个关键词吧。")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticStyle: {
	      "text-align": "center",
	      "font-size": "25px",
	      "color": "orange",
	      "margin-top": "100px"
	    }
	  }, [_vm._v("This is broadcast page!")])
	},staticRenderFns: []}

/***/ },
/* 60 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "movieDetails"
	  }, [_c('div', {
	    staticClass: "bigBox"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('section', {
	    staticClass: "subject-info clearfix"
	  }, [_c('div', {
	    staticClass: "conentL"
	  }, [_c('p', {
	    staticClass: "comment"
	  }, [_c('strong', {
	    staticClass: "grade"
	  }, [_vm._v(_vm._s(_vm.star == '0' ? '尚未上映' : _vm.star))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.ratings_count) + "人评价")])]), _vm._v(" "), _c('p', [_vm._l((_vm.data.countries), function(i) {
	    return _c('span', [_vm._v(_vm._s(i) + "/")])
	  }), _vm._v(" "), _vm._l((_vm.data.genres), function(i) {
	    return _c('span', [_vm._v(_vm._s(i) + "/")])
	  }), _vm._v(" "), _vm._l((_vm.data.directors), function(i) {
	    return _c('span', [_vm._v(_vm._s(i.name) + "(导演)/")])
	  }), _vm._v(" "), _vm._l((_vm.data.casts), function(item, i) {
	    return _c('span', [_vm._v(_vm._s(item.name) + _vm._s(i + 1 == _vm.data.casts.length ? '' : '/'))])
	  }), _vm._v(" "), _c('a', {
	    staticClass: "cl",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("用App查看影人资料")])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "img fr"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.datai,
	      "alt": "data.title"
	    }
	  })])])]), _vm._v(" "), _c('section', {
	    staticClass: "subject-summary"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.data.title) + "的剧情简介")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n          " + _vm._s(_vm.data.summary) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "section-content clearfix"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "page-swipe"
	  }, [_c('mt-swipe', {
	    attrs: {
	      "auto": 4000,
	      "show-indicators": false
	    }
	  }, [_c('mt-swipe-item', {
	    class: {
	      slide1: true
	    }
	  }, [_c('a', {
	    staticClass: "swipe-a",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "cover",
	    attrs: {
	      "src": __webpack_require__(38),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', [_c('span', [_vm._v("￥" + _vm._s(_vm.data.data.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.data.title))])]), _vm._v(" "), _c('p', [_vm._v("不可思议的友谊奇迹，人生路上柔软的智慧之光")])])])]), _vm._v(" "), _c('mt-swipe-item', {
	    class: {
	      slide2: true
	    }
	  }, [_c('a', {
	    staticClass: "swipe-a",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "cover",
	    attrs: {
	      "src": __webpack_require__(37),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', [_c('span', [_vm._v("￥" + _vm._s(_vm.data.data2.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.data2.title))])]), _vm._v(" "), _c('p', [_vm._v("帕蒂·史密斯《只是孩子》姊妹篇，如何面对人生的不断失去...")])])])]), _vm._v(" "), _c('mt-swipe-item', {
	    class: {
	      slide3: true
	    }
	  }, [_c('a', {
	    staticClass: "swipe-a",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "cover",
	    attrs: {
	      "src": __webpack_require__(39),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', [_c('span', [_vm._v("￥" + _vm._s(_vm.data.data3.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.data3.title))])]), _vm._v(" "), _c('p', [_vm._v("摄影教父阮义忠的少年画家梦，海外艺术家的海上访问记")])])])])], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h2', [_vm._v("豆瓣纸书")]), _vm._v(" "), _c('span', {
	    staticClass: "fr cl"
	  }, [_vm._v("更多")])])
	}]}

/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "commingsoon"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    ref: "moviesUl",
	    staticClass: "section-content"
	  }, [_c('ul', {
	    staticClass: "items"
	  }, _vm._l((_vm.movies), function(movie, movieindex) {
	    return _c('li', {
	      staticClass: "item"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/movie/subject/' + movie.id
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "javascript:;"
	      }
	    }, [_c('div', {
	      staticClass: "item-img"
	    }, [_c('img', {
	      staticStyle: {
	        "width": "100px",
	        "height": "148px"
	      },
	      attrs: {
	        "src": movie.images.medium,
	        "alt": ""
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "item-title"
	    }, [_vm._v(_vm._s(movie.title))]), _vm._v(" "), _c('div', {
	      staticClass: "rating"
	    }, [_c('span', {
	      staticClass: "rating-stars"
	    }, _vm._l((_vm.starClasses[movieindex]), function(starClass) {
	      return _c('span', {
	        staticClass: "rating-star",
	        class: starClass
	      })
	    })), _vm._v(" "), _c('span', {
	      staticClass: "rating-average"
	    }, [_vm._v(_vm._s(movie.rating.average))])])])])], 1)
	  }))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h2', [_vm._v("即将上映")]), _vm._v(" "), _c('a', {
	    staticClass: "more",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("更多")])])
	}]}

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('Vheader'), _vm._v(" "), _c('div', {
	    staticClass: "page"
	  }, [_c('transition', {
	    attrs: {
	      "enter-active-class": "animated flipInY"
	    }
	  }, [_c('router-view')], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 67 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.e7734f56056236029aca.js